module.exports = __webpack_public_path__ + "static/media/profile-settings.b80574be.svg";